export interface CreateSeparateDictionaryRequest {
  name: string
  separateName: string
}

export function CreateSeparateDictionaryRequestToJSON(
  value: CreateSeparateDictionaryRequest
): any {
  return {
    name: value.name !== '' ? value.name : undefined,
    separate_name: value.separateName !== '' ? value.separateName : undefined
  }
}
